import { render, staticRenderFns } from "./CertificateTypes.vue?vue&type=template&id=12c0c089&scoped=true"
import script from "./CertificateTypes.vue?vue&type=script&lang=ts"
export * from "./CertificateTypes.vue?vue&type=script&lang=ts"
import style0 from "./CertificateTypes.vue?vue&type=style&index=0&id=12c0c089&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0c089",
  null
  
)

export default component.exports